import { shallow } from 'zustand/shallow'
import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'

import EsdtForm from './EsdtForm'
import EvmForm from './EvmForm'
import ChainOptions from '../../components/ChainOptions'
import NetworkOptions from '../../components/NetworkOptions'
import { useChainAndNetwork } from 'src/store/chainAndNetwork'
import SectionTitle from '../../components/kit/SectionTitle'
import FormTitle from '../../components/kit/FormTitle'
import '../Form.scss'

const MintNft = () => {
  const { chain } = useChainAndNetwork(
    (state) => ({
      chain: state.chain,
    }),
    shallow,
  )

  const renderChainForms = () => {
    switch (chain) {
      case 'bnb':
      case 'ethereum':
      case 'polygon':
        return <EvmForm />
      case 'multiversx':
        return <EsdtForm />
      // return <Typography variant="h5"> MVX Form</Typography>;
      default:
        return <div>No form selected</div>
    }
  }

  return (
    <Paper
      elevation={2}
      sx={{
        background: '#181D38',
        color: '#fff',
        padding: '32px 24px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: '15px',
        width: '100%',
        boxSizing: 'border-box',
        borderRadius: '8px',
      }}>
      <FormTitle title="Mint NFT" />
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          gap: '20px',
        }}>
        <SectionTitle title="Choose the chain" />
        <ChainOptions />
        <NetworkOptions />
      </Box>
      {renderChainForms()}
    </Paper>
  )
}

export default MintNft
